import { toast, ToastOptions } from "react-toastify";

export interface ToastFn {
    (
        message: string,
        delay?: number,
    ): void;
};

/** interface */
export interface ToastActions {
    info: ToastFn;
    error: ToastFn;
    success: ToastFn;
    warn: ToastFn;
};

const toastProps: ToastOptions<unknown> = {
    position: "top-center",
    autoClose: 10000,
    closeOnClick: false,
    draggable: false,
    hideProgressBar: true,
};

export class Toaster implements ToastActions {
    error = (message: string, delay?: number) => {
        if (delay) {
            toastProps.autoClose = delay;
        }

        //console.error("showToastMessage: " + message);
        toast.error(
            message, 
            toastProps,
        );
    };

    info = (message: string, delay?: number) => {
        if (delay) {
            toastProps.autoClose = delay;
        }

        //console.info("showToastMessage: " + message);
        toast.info(
            message, 
            toastProps,
        );
    };

    success = (message: string, delay?: number) => {
        if (delay) {
            toastProps.autoClose = delay;
        }

        //console.log("showToastMessage: " + message);
        toast.success(
            message, 
            toastProps,
        );
    };

    warn = (message: string, delay?: number) => {
        if (delay) {
            toastProps.autoClose = delay;
        }

        //console.warn("showToastMessage: " + message);
        toast.warn(
            message, 
            toastProps,
        );
    };
};

export const toastService = new Toaster();
